import React, { useState, useEffect, useRef } from 'react';
import { Button } from '@mui/material';
import ImageRatingComponent from './ImageRatingComponent';
import { useNavigate } from "react-router-dom";
import { tutorialText } from '../locales/en';

const Welcome = () => {
  const navigate = useNavigate();

  const handleTutorialDone = () => {
    navigate(window.location.href = '/rating?uuid=' + new URLSearchParams(window.location.search).get('uuid') + '&taskid=0&iteration=0');
  };

  return(
    <div className='main'>
      <h2>Tutorial</h2>
      <p>
        {tutorialText}{' '}
        <span
          onClick={handleTutorialDone}
          style={{
            textDecoration: 'underline',
            cursor: 'pointer',
            color: '#21696dff',
            fontWeight: 'bold'
          }}
        >
          Click here to continue
        </span>
      </p>
      <div id="iterateController">
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '15px' }}>
        </div>
        <div className='flex'>
          <ImageRatingComponent uuid="tutorial-uuid" timer={false} debugging={false} tutorial={true} />
        </div>
      </div>
    </div>
  );
};


export default Welcome;
